import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface AccessBarProps {
  selectedTab: string
  onSelectTab: (tab: string) => void
}

const AccessBar: React.FC<AccessBarProps> = ({ selectedTab, onSelectTab }) => {
  const { t } = useTranslation()

  return (
    <Box width="100%">
      <HStack spacing="24px" align="stretch" pl={5}>
        <HStack
          spacing="12px"
          py="18px"
          px="16px"
          height="56px"
          _hover={{ backgroundColor: '#D0DDFF4D' }}
          cursor="pointer"
          color="solid.900"
          onClick={() => onSelectTab('admins')}
          borderBottomColor={selectedTab === 'admins' ? 'primary.100' : 'transparent'}
          borderBottomWidth={selectedTab === 'admins' ? '2px' : '0px'}
        >
          <Text textStyle="l-s">{t('settings.accessBar.accounts')}</Text>
        </HStack>
        <HStack
          spacing="12px"
          py="18px"
          px="16px"
          height="56px"
          _hover={{ backgroundColor: '#D0DDFF4D' }}
          cursor="pointer"
          color="solid.900"
          onClick={() => onSelectTab('roles')}
          borderBottomColor={selectedTab === 'roles' ? 'primary.100' : 'transparent'}
          borderBottomWidth={selectedTab === 'roles' ? '2px' : '0px'}
        >
          <Text textStyle="l-s">{t('settings.sections.roles')}</Text>
        </HStack>
      </HStack>
    </Box>
  )
}

export default AccessBar
